import { useV2ListPrivilegesQuery } from "@generated";
import { scopeOf } from "../types";
import type { PrivilegeDefinition, PrivilegeScope } from "../types";

// Keyed by every PrivilegeScope so it stays in sync if a scope is added.
export type GroupedPrivileges = Record<PrivilegeScope, PrivilegeDefinition[]>;

export const usePrivilegeDefinitions = () => {
  const { data, isLoading, error } = useV2ListPrivilegesQuery();

  const definitions: PrivilegeDefinition[] = (data?.data ?? []).map((p) => ({
    id: String(p.id),
    scope: scopeOf(String(p.id)),
    name: p.attributes?.name ?? "",
    description: p.attributes?.description ?? "",
    levels: p.attributes?.levels ?? [],
    // Wire key stays kebab-case (matches the generated type and usePrivilegeCheck).
    defaultLevel: p.attributes?.["default-level"] ?? "",
  }));

  const grouped: GroupedPrivileges = {
    projects: definitions.filter((d) => d.scope === "projects"),
    settings: definitions.filter((d) => d.scope === "settings"),
    reports: definitions.filter((d) => d.scope === "reports"),
  };

  const userPreset = definitions.reduce<Record<string, string>>((acc, d) => {
    if (d.defaultLevel) acc[d.id] = d.defaultLevel;
    return acc;
  }, {});

  return { definitions, grouped, userPreset, isLoading, error };
};

export default usePrivilegeDefinitions;
